import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import {
  getPlanShares,
  createPlanShare,
  type PlanSharesResponse,
  type ShareCreateBody,
} from '@/api/shares'
import { queryKeys } from '@/lib/queryKeys'

/**
 * Hook for fetching plan shares
 */
export function usePlanShares(planId: string) {
  return useQuery<PlanSharesResponse>({
    queryKey: queryKeys.shares.byPlanId(planId),
    queryFn: () => getPlanShares(planId),
    enabled: !!planId,
  })
}

/**
 * Hook for creating a plan share
 */
export function useSharePlan(planId: string) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: ShareCreateBody) => createPlanShare(planId, data),
    onSuccess: () => {
      // Invalidate shares query to refetch the list
      queryClient.invalidateQueries({
        queryKey: queryKeys.shares.byPlanId(planId),
      })
    },
  })
}
